import {
  DateTextInput,
  type DateTextInputCalendarProps,
  type DateTextInputProps,
} from '@stenajs-webui/calendar';
import type { FC } from 'react';
import { useLocalDateFormat } from '../../common/hooks/useLocalDateFormat';
import { useLocalDateInputState } from '../../common/hooks/useLocalDateInputState';
import type { TrackerCategory } from '../../common/tracking/trackerService';
import {
  type TrackerAction,
  trackEditEvent,
} from '../../use-cases/simple-create/hooks/UseTrackingTextInput';

export interface CommonDateInputFieldProps extends DateTextInputProps<unknown> {
  calendarProps?: DateTextInputCalendarProps<unknown>;
  changed?: boolean;
  isValid?: boolean;
  trackerAction: TrackerAction;
  trackerCategory: TrackerCategory;
}

export const CommonDateInputField: FC<CommonDateInputFieldProps> = ({
  trackerCategory,
  onValueChange,
  disabled,
  value,
  trackerAction,
  changed,
  isValid = true,
  variant,
  ...props
}) => {
  const onInternalOnChange = (date: string) => {
    onValueChange?.(date);

    if (date) {
      trackEditEvent(trackerAction, trackerCategory);
    }
  };

  const [inputValue, setInputValue] = useLocalDateInputState(value ?? '', onInternalOnChange);

  const dateFormat = useLocalDateFormat();

  return (
    <DateTextInput
      {...props}
      onValueChange={setInputValue}
      dateFormat={dateFormat}
      placeholder={dateFormat.toUpperCase()}
      variant={isValid ? variant : 'error'}
      disabled={disabled}
      value={inputValue}
      style={{
        fontStyle: changed ? 'italic' : 'normal',
        fontWeight: changed ? 'bold' : 'normal',
      }}
    />
  );
};
